import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Amplitude from '../utils/amplitudeHelper'
import PageWithBg from '../components/PageWithBg'
import LoadIcon from '../components/LoadIcon'
import { useDispatch } from 'react-redux'
import { muteMusic, unmuteMusic } from '../ducks/layout'
import config from '../config'
import { SIZES } from '../styles/theme'
import ChatSection from '../components/ChatSection'
import screen from '../images/backdrops/screen.png'
import { useHistory } from 'react-router-dom'
import routes from '../routes'
import { ChatKfairDb, HallDb, AttendanceDb } from '../firebaseConfig'
import { toast } from 'react-toastify'
import { useObject } from 'react-firebase-hooks/database'

const Page = styled.div`
  overflow: hidden;
  .content {
    ${config.layout.auditoriumVid}
    position: absolute;
    background: black;

    iframe {
      height: 100%;
      width: 100%;
    }
  }
  .screen-container {
    position: fixed;
    top: 8%;
    bottom: 30%;
    left: 2%;
    right: 34%;
  }
  #screen {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .chat {
    max-width: 350px;
    position: fixed;
    padding-top: ${SIZES.navHeight};
    top: 0;
    left: 67%;
    bottom: 0;
    right: 5%;
    z-index: 30;
  }
  .attendance {
    position: fixed;
    top: 10%;
    left: 5%;
    display: flex;
    animation: heartbeat 5s infinite;

    .action-label {
      color: white;
      font-weight: 500;
      margin: 0 16px;
      font-style: italic;
      align-self: center;
    }
    button {
      background: transparent;
      border: none;
      padding: 0;
      margin: 0 auto;
      img {
        border-radius: 50%;
      }
    }
    &:hover {
      .action-label,
      img {
        transition: 500ms;
        transform: scale(1.2);
      }
      img {
        box-shadow: 0px 0px 30px 6px #ffad2c;
      }
    }
  }
  
`

export default function AuditoriumPage({
  liveUrl,
  hallBg,
  hallNumber,
  currentUser,
}) {
  const [isLoading, setIsLoading] = useState(true)
  const [snapshot, loading, error] = useObject(HallDb)
  const [attendSnapshot, attendLoading, attendError] = useObject(AttendanceDb)
  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    if (!attendLoading) {
      if (attendSnapshot.val()) {
        Amplitude.takeAttendance(hallNumber)
      }
    }
  }, [attendLoading, attendSnapshot, currentUser.id, hallNumber])
  
  useEffect(() => {
    dispatch(muteMusic())

    return () => {
      if (localStorage.getItem('muted') === 'false') {
        dispatch(unmuteMusic())
      }
    }
  }, [dispatch])

  useEffect(() => {
    document.title = `${config.eventName} | Conference`
  }, [])

  
  useEffect(() => {
    if (!loading) {
      if (!snapshot.val() && currentUser.role !== 'superadmin') {
        toast('Conference Hall is not available now.', {
          toastId: 'eventToast',
        })
        history.push(routes.lobby)
      } else {
        Amplitude.visitAuditorium(hallNumber)
      }
    }
  }, [loading, snapshot, currentUser.id, hallNumber])

  if (loading || error) {
    return <LoadIcon />
  }
  return (
    <Page>
      <PageWithBg bgImg={hallBg}>
        <div className="screen-container">
          <img id="screen" src={screen} alt="screen" />
          <div className="content">
            {isLoading && <LoadIcon />}
            <iframe
              title="Live Broadcast"
              src={liveUrl}
              allow="autoplay; fullscreen"
              allowFullScreen
              frameBorder="0"
              onLoad={() => {
                setIsLoading(false)
              }}
            />
          </div>
        </div>
        <div className="chat h-100">
          <ChatSection
            currentUser={currentUser}
            firebaseDb={ChatKfairDb}
            hallName="MainAuditorium"
          />
        </div>
      </PageWithBg>
    </Page>
  )
}
